module.exports = __webpack_public_path__ + "media/brands/hobby-2d74f3b8.png";